import { Injector } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ModalUtils } from '../../../../../utils/modal-utils';
import { AccountAssetSelectionUnlockFundsModalComponent } from './account-asset-selection-unlock-funds-modal.component';
import { UnlockFundsModalConfig } from './unlock-funds-modal-config';

export function openUnlockFundsModal(
  ngbModal: NgbModal,
  injector: Injector,
  config: UnlockFundsModalConfig
): NgbModalRef {
  const modalRef = ngbModal.open(
    AccountAssetSelectionUnlockFundsModalComponent,
    ModalUtils.defaultModalOptions(injector)
  );
  (modalRef.componentInstance as AccountAssetSelectionUnlockFundsModalComponent).setConfig(config);
  return modalRef;
}
